import React from 'react'
import { EnvironmentOutlined, InfoCircleOutlined, NumberOutlined, ApartmentOutlined } from '@ant-design/icons';
import { Row, Col, Card, Tooltip, Skeleton, Button, Empty } from 'antd';
import moment from 'moment';
export const _list = (props) => {
  const { OfferList, onViewOffer, isLoading } = props;

  return (
    <>
      <Row justify="left">
        <Col md={24} xs={24}>
          <Card title={'My Offers'} className="documents-card iqor-header">
            <Row style={{ justifyContent: (OfferList == null ? 'center' : 'left') }}>
              <Skeleton loading={isLoading} active>
                <>
                  {
                    (OfferList == null) ?
                      (<Empty
                        description={'You currently do not have any offers.'}
                      />) :
                      (
                        OfferList && OfferList.map((item, i) => {
                          return (
                            <Col md={{ span: 6 }} xs={{ span: 24 }}>
                              <div style={{ cursor: 'pointer' }} className="jobs-applied-col" key={i}>
                                <Tooltip placement="topLeft" title={`${item.jobTitleName} - #${item.jobReqID}`} arrowPointAtCenter>
                                  <Card title={`Offer Date ${moment(item.offerSentDt ?? item.createdDt).format('MM/DD/YYYY')}`} className="jobs-applied saved-applications">
                                    <Row align="middle" gutter={16} style={{ marginLeft: '3em' }}>
                                      <Col>
                                        <ApartmentOutlined className="inline-icon" twoToneColor="#52c41a" />
                                      </Col>
                                      <Col>
                                        <b>Position Title</b><br />
                                        {item.jobTitleName}
                                      </Col>
                                    </Row>
                                    <Row align="middle" gutter={16} style={{ marginLeft: '3em' }}>
                                      <Col>
                                        <NumberOutlined className="inline-icon" twoToneColor="#52c41a" />
                                      </Col>
                                      <Col>
                                        <b>Req#</b><br />
                                        {item.jobReqID}
                                      </Col>
                                    </Row>
                                    <Row align="middle" gutter={16} style={{ marginLeft: '3em' }}>
                                      <Col>
                                        <EnvironmentOutlined className="inline-icon" twoToneColor="#52c41a" />
                                      </Col>
                                      <Col>
                                        <b>Location</b><br />
                                        {item.workLocationName}
                                      </Col>
                                    </Row>
                                    <Row align="middle" gutter={16} style={{ marginLeft: '3em' }}>
                                      <Col>
                                        <InfoCircleOutlined className="inline-icon" twoToneColor="#52c41a" />
                                      </Col>
                                      <Col>
                                        <b>Status</b><br />
                                        {item.offerAccptStatus}
                                      </Col>
                                    </Row><br />
                                    <Row justify={'end'} gutter={16} >
                                      <Col>
                                        <Button
                                          type="danger"
                                          htmlType="button"
                                          onClick={e => onViewOffer(e, item)}
                                        >View Offer</Button>
                                      </Col>
                                    </Row>
                                  </Card>
                                </Tooltip>
                              </div>
                            </Col>

                          )
                        })
                      )
                  }
                </>
              </Skeleton>
            </Row>
          </Card>
        </Col>
    </Row>
    </>
  )
}
